<template>
  <v-container fluid>
    <!-- Title -->
    <v-row no-gutters>
      <v-col cols="12">
        <v-card color="transparent" flat dark>
          <div class="text-h4 font-weight-bold text-center" style="padding: 5vh">Booking Profile Setting</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Body -->
    <v-row no-gutters>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-card rounded="lg" width="90%" class="pa-2">
            <v-card-subtitle style="display: inline-block">Booking Profiles (Total #{{ total_record }} Records)</v-card-subtitle>
            <div style="display: inline-block; float: right" class="mt-4 mr-4">
              <v-btn small depressed color="primary" @click="INIT_BOOKING_PROFILE_DIALOG(null)">
                <v-icon left small>mdi-plus</v-icon>
                New Profile
              </v-btn>
            </div>

            <v-card-text>
              <p class="text-body-2 grey--text text--darken-1">
                Each imported booking row is routed by its CS Center value. Rows whose CS Center matches no active profile fall back to the default profile.
              </p>

              <!-- items-per-page=-1: the footer is hidden, so Vuetify would otherwise paginate
                   at 10 and strand every profile after the tenth. -->
              <v-data-table :loading="bookingProfiles.loading" hide-default-footer :items-per-page="-1" :headers="bookingProfiles.headers" :items="bookingProfiles.items">
                <!-- Index -->
                <template v-slot:[`item.index`]="{ item }">
                  {{ bookingProfiles.items.indexOf(item) + 1 }}
                </template>

                <!-- Target Queue -->
                <template v-slot:[`item.service_type`]="{ item }">
                  {{ serviceTypeDisplay(item.service_type_id) }}
                </template>

                <!-- Fallback Queue -->
                <template v-slot:[`item.fallback_service_type`]="{ item }">
                  {{ serviceTypeDisplay(item.fallback_service_type_id) }}
                </template>

                <!-- CS Center -->
                <template v-slot:[`item.source_cs_center`]="{ item }">
                  {{ item.source_cs_center || '-' }}
                </template>

                <!-- Default -->
                <template v-slot:[`item.is_default`]="{ item }">
                  <v-chip v-if="Number(item.is_default) === 1" x-small label color="primary" dark>Default</v-chip>
                  <span v-else>-</span>
                </template>

                <!-- Active -->
                <template v-slot:[`item.active`]="{ item }">
                  <v-chip x-small label :color="Number(item.active) === 1 ? 'success' : 'grey'" dark>{{ Number(item.active) === 1 ? 'Active' : 'Inactive' }}</v-chip>
                </template>

                <!-- Action -->
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn color="primary" icon small @click="INIT_BOOKING_PROFILE_DIALOG(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn color="error" icon small @click="removeProfile(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-row>
      </v-col>
    </v-row>

    <bookingProfileDialog />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import bookingProfileDialog from '@/components/dialogs/bookingProfileDialog'
import bookingDisplay from '@/mixins/bookingDisplay'

export default {
  name: 'BookingProfiles',
  mixins: [bookingDisplay],
  components: { bookingProfileDialog },
  computed: {
    ...mapState(['bookingProfiles', 'general']),
    ...mapGetters(['hasOtherDefaultProfile']),
    total_record() {
      return this.bookingProfiles.items.length || ''
    }
  },
  methods: {
    ...mapActions(['fetchBookingProfiles', 'fetchServiceTypeList', 'deleteBookingProfile']),
    ...mapMutations(['INIT_BOOKING_PROFILE_DIALOG', 'SET_SNACKBAR']),
    removeProfile(profile) {
      // Unmatched CS Center values are routed to the default profile, so the last
      // default must not disappear.
      if (Number(profile.is_default) === 1 && !this.hasOtherDefaultProfile(profile.booking_import_profile_id)) {
        this.SET_SNACKBAR({ status: true, color: 'error', text: 'This is the only default profile. Set another profile as default before deleting it.', icon: 'close', timeout: '4000' })
        return
      }
      if (!window.confirm(`Delete booking profile "${profile.name}"?`)) return
      this.deleteBookingProfile({ params: { booking_import_profile_id: profile.booking_import_profile_id } })
    }
  },
  mounted() {
    // The queue selects and the table labels both read general.queues.
    this.fetchServiceTypeList()
    this.fetchBookingProfiles()
  }
}
</script>
